import styled from '@emotion/styled'

export const PaymentInputWrapper = styled.div`
  width: 45%;
`
